export const defaultStyle = {
  Container: "bg-red-600",
  description: "font-Regular",
  stepsContainer:
    "stepsContainer flex flex-wrap my-60 px-20 lg:px-auto justify-center",
  olClass: "list-decimal w-100% lg:w-[54%] md:w-[77%] mx-auto",
  liDescription:
    "liDescription inline-flex items-center md:w-[81.333%] w-3/4 ml-[20px] text-[18px]",
  roundedHeading:
    "bg-liBgRound reciepeLi bg-contain bg-no-repeat md:h-[78px]  md:w-[78px] h-[35px] w-[42px] font-Bold md:text-[45px] text-[30px] flex  items-center justify-center w-[10%]",
  receipeHeading:
    "receipeHeading text-darkBlue text-[30px] font-Bold w-100% mx-auto flex justify-center my-0 leading-[30px] tracking-[1px]",
  receipeSubheading:
    "subheading text-darkBlue text-[30px] font-Bold w-100% justify-center mx-auto flex text-center mt-[4.5px] mb-0 leading-[30px]",
  receipeMainWrpr:
    "receipeMainWrpr lg:w-[1170px] w-100% mx-auto flex flex-wrap ",
  contentWrpr:
    "w-100% flex max-md:flex-col-reverse m-0 mb-[50px] pb-[50px] box-border border-b-1 border-gray md:max-w-md lg:max-w-lg xl:max-w-xl pl-[15px] md:pl-[0px]",
  contentLeftWrpr:
    "contentLeftWrpr w-full w-[33.33%] [&:img]:hidden md:block md:pl-0 md:flex md:pr-[15px] md:align-center md:flex-wrap ",
  imageSite:
    "w-100% align-middle box-border hidden md:block lg:w-[397px] lg:h-[225px]  md:w-[215px] md:h-[123px] md:align-middle lg:mb-[5px] md:mb-[10px]",
  receipeHeadingOne:
    "box-border  lg:w-[397px] lg:h-[79px] md:mb-[16px] lg:mb-[0px]  ",
  receipeHeadingTwo:
    "fa-tags w-[335px] h-[42px] text-[12px] md:text-[16px] uppercase md:tracking-[2.2px] text-left text-purple mb-0 lg:w-[397px] lg:h-[63px]  tracking-[0.53px] font-Regular leading-[18px] font-bold cursor-pointer box-border  md:w-[215px] inline-block lg:mb-[16px] md:leading-[24px] text-left  ",
  roundedHeading: "box-border  ",
  HeadOne:
    "text-[12px] md:text-[14px] mb-0 font-bold tracking-[0.35px] leading-[18px] md:leading-[21px] text-left font-Regular  text-black mt-0 box-border ",
  HeadTwo:
    "text-[24px] mb-[15px] md:leading-[43.2px] font-light md:text-[36px] cursor-pointer text-left tracking-normal leading-[28.8px] mt-0 box-border font-Light text-green hover:underline hover:decoration-purple md:mb-[25px]  ",
  HeadThree:
    "text-[14px] md:text-[18px] font-Regular font-normal tracking-[0.53px] leading-[21px] md:leading-[27px] text-left text-black mt-0 mb-[16px] box-border",
  mainHeading:
    "md:pl-[150px] lg:w-[66.66%] w-full md:pr-0 md:flex md:align-center md:flex-wrap md:box-border w-100% lg:items-center",
  underline: "hover:text-orange-700 hover:underline m-[5px] ",
  imageLinkOne:
    "inline-flex md:mb-[10px] leading-[1.5] hover:text-orange hover:underline pl-[5px]",
  videoWrapper: "",
}

export const SLIDER_CARD = {
  contentWrpr: "md:max-w-md lg:max-w-lg xl:max-w-xl md:mx-[24px] lg:mx-auto md:px-[15px]  ",
  imageSite:
    "cursor-pointer block font-Regular text-[21px] w-full object-cover",
  videoWrapper: "",
  contentLeftWrpr: "",
  imageLinkTwo: "headingArrow",
  HeadTwo:
    "text-[12px] md:text-[16px] font-Regular font-bold tracking-[2.2px] leading-[24px] text-left text-purple hover:text-orange hover:underline relative",
  HeadThree: "text-purple",
  receipeHeadingOne: "fa-tags flex pt-[10px] inline",
  imageLinkOne: "ml-[6px] inline-block",
  receipeHeadingTwo:
    "inline text-[14px] md:text-[16px] uppercase md:tracking-[2.2px] leading-[24px] text-purple tracking-[0.53px] font-Regular font-bold cursor-pointer box-border hover:[&>div>a]:text-orange hover:[&>div>a]:underline",
}

export const JOB_CARD = {
  contentWrpr: "jobCardCont",
  HeadThree: "HeadThree",
  HeadOne:
    "HeadOne [&>p]:text-[12px] [&>p]:tracking-[0.35px] [&>p]:font-Bold [&>p]:leading-[18px]",
  imageLinkTwo:
    "imageLinkTwo font-Light text-green text-[18px] md:text-[30px] flex mb-[8px] tracking-[2.2px] leading-[21.6px] md:leading-[36px] hover:underline hover:decoration-purple",
}

export const PRESS_CARD = {
  HeadOne:
    "HeadOne [&>p]:text-[12px] [&>p]:tracking-[0.35px] [&>p]:font-Bold [&>p]:leading-[18px] mb-[44px] [&>a]:text-[10px] [&>a]:md:text-[14px] [&>a]:font-bold [&>a]:tracking-[0.35px] hover:[&>a]:text-orange hover:[&>a]:underline",
  HeadTwo:
    "text-[14px] md:text-[21px] font-Regular  tracking-[0.53px] leading-[21px] md:leading-[31.5px] text-left text-black hover:text-orange hover:underline relative max-[767px]:pb-[20px]",
}
export const CONTACT_CARD = {
  HeadOne: "HeadOne",
  HeadTwo:
    " text-[12px] md:text-[21px] font-Regular  tracking-[0.53px] leading-[31.5px] text-left text-black  relative",
  HeadThree: "HeadThree contactTEXT pb-[25px]",
  description: "description",
  imageSite:'imageSite',
  contentLeftWrpr:'contentLeftWrpr',
  contentWrpr:'contentWrpr',
}

export const CONTACT_CARD_IMAGE = {
  HeadOne: "HeadOne",
  HeadTwo:" text-[12px] md:text-[21px] font-Regular  tracking-[0.53px] leading-[31.5px] text-left text-black  relative",
  HeadThree: "HeadThree contactTEXT pb-[25px]",
  description: "description",
  imageSite:'imageSite',
  contentLeftWrpr:'contentLeftWrpr',
  contentWrpr:'contentWrpr flex flex-col-reverse',
}

export const OVERVIEW_CARD = {
  ...CONTACT_CARD,
}
export const videoWrapper = ""
export const description = ""
export const VIDEO_STORY_CARD = {
  ...defaultStyle,
}
